let ingredientsData = [
	{
		id: 1,
		item: "banana",
		kcal: 89,
		protein: 1.09,
		fat: 0.33,
		carbs: 22.84,
		fiber: 2.6,
		sugars: 12.23
	},
	{
		id: 2,
		item: "walnuts",
		kcal: 654,
		protein: 15.23,
		fat: 65.21,
		carbs: 13.71,
		fiber: 6.7,
		sugars: 2.61
	},
	{
		id: 3,
		item: "peanuts",
		kcal: 567,
		protein: 25.8,
		fat: 49.24,
		carbs: 16.13,
		fiber: 8.5,
		sugars: 4.72
	},
	{
		id: 4,
		item: "oats",
		kcal: 379,
		protein: 13.15,
		fat: 6.52,
		carbs: 67.7,
		fiber: 10.1,
		sugars: 0.99
	},
	{
		id: 5,
		item: "dates",
		kcal: 282,
		protein: 2.45,
		fat: 0.39,
		carbs: 75.03,
		fiber: 8,
		sugars: 63.35
	},
	{
		id: 6,
		item: "almonds",
		kcal: 579,
		protein: 21.15,
		fat: 49.93,
		carbs: 21.55,
		fiber: 12.5,
		sugars: 4.35
	},
	{
		id: 7,
		item: "raisins",
		kcal: 299,
		protein: 3.3,
		fat: 0.25,
		carbs: 79.32,
		fiber: 4.5,
		sugars: 65.18
	},
	{
		id: 8,
		item: "figs",
		kcal: 249,
		protein: 3.3,
		fat: 0.92,
		carbs: 63.9,
		fiber: 9.8,
		sugars: 47.9
	}
]
export default ingredientsData